export default class Venues {

  constructor () {
    this.milesMultiplier = 3959
    this.centerLatitude = 55.4138532
    this.centerLongitude =  -1.7080895999999939
    this.mapZoom = 12
    this.isInternetExplorer11 = navigator.userAgent.toLowerCase().indexOf('trident') > -1,
    this.marker_url = '/wp-content/themes/my-northumberland-wedding-theme/dist/img/google-map-icon.png',

    this.style = [
                  {
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#f5f5f5"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.icon",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#616161"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                      {
                        "color": "#f5f5f5"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#bdbdbd"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#eeeeee"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e3edd3"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#ffffff"
                      }
                    ]
                  },
                  {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#9ca4b2"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#616161"
                      }
                    ]
                  },
                  {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                    ]
                  },
                  {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e5e5e5"
                      }
                    ]
                  },
                  {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#eeeeee"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#c9c9c9"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#B5CBE7"
                      },
                      {
                        "lightness": 5
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                    ]
                  }
                ];

    this.mapOptions = {
      center: new google.maps.LatLng(this.centerLatitude, this.centerLongitude),
      zoom: this.mapZoom,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: this.style
    }

    this.markers = []

    /*if( $( window ).width() < 769 ) {
      this.center_latitude = 51.390020
      this.center_longitude = -4.189840
    }*/
  }

  init () {



    $(document).on('change', '.update-filters', ({currentTarget}) => {
      const self = this
      self.resetMap()
      self.filterTheVenues()
      //self.filterLocations()
    });

    // close any open filter dropdown when clicking outside of it
    $(document).on('click', ({target}) => {
      $('.venue-filters__form .dropdown-checkbox:checked').each(function() {
        if( !$(this).closest('.dropdown-wrapper')[0].contains(target) )
          this.checked = false
      })
    });

    $(document).on('change', '.update-supplier-filters', ({currentTarget}) => {
      const self = this
      self.resetMap()
      self.filterTheSuppliers()
      //self.filterLocations()
    });

    if( $('#venuesMap').length) {

      /* contact map*/
      const self = this

      self.map = new google.maps.Map(document.getElementById('venuesMap'), this.mapOptions)
      self.geocoder = new google.maps.Geocoder()

      self.resetMap()

      const coords = new google.maps.LatLng(this.centerLatitude, this.centerLongitude)

      self.map.setCenter(coords)

      self.filterLocations()


      }
  }

  zoomMap() {
    if( $( window ).width() < 1088){
      this.map.setZoom(8);
    } else {
      this.map.setZoom(10);
    }
  }

  resetMap() {
    this.markers.forEach((marker) => {
      marker.setMap(null)
    })

    this.markers = []
    this.bounds = new google.maps.LatLngBounds()
  }

filterTheVenues(){

    var self = this

    var checked_filters = $('.venue-filters__form input.update-filters:checked');
    var selected_options = {};

    // get all selected radios/checkboxes, grouped by taxonomy (input name)
    $.each(checked_filters, function( index, value ) {

      if( typeof selected_options[$(value).attr('name')] === 'undefined')
        selected_options[$(value).attr('name')] = [];

      selected_options[$(value).attr('name')].push($(value).val());

    });

    $.ajax({
      url : ajaxapp.ajax_url,
      type : 'post',
      data : {
        action : 'filter_venues',
        selections : selected_options
      },
      success : function( response ) {

        var response_array = JSON.parse( response );
        $("#filterResponse").html( response_array.html );

        self.filterLocations( response_array.venues );
      }

    });

  }

  filterTheSuppliers(){

      var self = this

      var venue_filters = $('.filters select option:selected');
      var checkbox_features = $('.product-options input:checkbox:checked');
      var selected_options = {};

      // get all selected slider values
      $.each(venue_filters, function( index, value ) {

        if( typeof selected_options[$(value).parent().attr('name')] === 'undefined')
          selected_options[$(value).parent().attr('name')] = [];

        if( $(value).val() )
          selected_options[$(value).parent().attr('name')].push($(value).val());

      });

      // get all selected checkboxes
      $.each(checkbox_features, function( index, value ) {

        if( typeof selected_options[$(value).attr('name')] === 'undefined')
          selected_options[$(value).attr('name')] = [];

        selected_options[$(value).attr('name')].push($(value).val());

      });

      $.ajax({
        url : ajaxapp.ajax_url,
        type : 'post',
        data : {
          action : 'filter_suppliers',
          selections : selected_options
        },
        success : function( response ) {

          var response_array = JSON.parse( response );
          $("#filterResponse").html( response_array.html );

          self.filterLocations( response_array.suppliers );
        }

      });

    }


  filterLocations( venues ) {

    var getall = 0;

    if( typeof venues === 'undefined' ){
        getall = 1;
    } else{
      $('.venues').css('order', 2);
      $('.venue-list').css('order', 1);

    }

    var show_marker = false;

    const self = this

    const infowindow = new google.maps.InfoWindow({content: ""})

    if( getall == 0 && venues.length == 0){
      self.resetMap();
    } else{

          $('.location_marker').each(function() {

            const latitude = $(this).attr('data-lat'),
                  longitude = $(this).attr('data-lng')

            var venue_id = parseInt($(this).attr('data-rel'));

            show_marker = false;

            if( getall == 1 ){
              show_marker = true;
            } else{

              if($.inArray(venue_id, venues) != -1){
                show_marker = true;
              } else {
                show_marker = false;
              }
            }

            if ( show_marker == true ) {

              const label = $(this).attr('data-index'),
                    locationContent = $(this).html(),
                    marker = new google.maps.Marker({
                      position: new google.maps.LatLng(latitude, longitude),
                      map: self.map,
                      visible: true,
                      content: locationContent,
                      label: '', //$label,
                      zIndex: 2,
                      icon: self.marker_url

                    })

              google.maps.event.addListener(marker, 'click', () => {
                infowindow.setContent(`<div class="scrollFix">${marker.content}</div>`)
                infowindow.open(self.map, marker)
              })

              marker.setMap(self.map)

              //extend the bounds to include each marker's position
              self.bounds.extend(marker.position)

              self.markers.push(marker)

            }

            if( self.markers.length > 1){
              self.map.fitBounds(self.bounds)
            }

            self.zoomMap()

          })
    }


  }


}
